import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { GET_TYPE_PARAMETERS } from "./actionTypes";
import { getTypeParamsSuccess, getTypeParamsError } from "./actions";

// Include call API
import { getParameterAPI } from "../../../api/parameters";

const paramsAPI = getParameterAPI();

function* getTypeParameters({ payload: { user, type } }) {
  try {
    const response = yield call(paramsAPI.getParametersType, user.token, type);
    console.log(response)
    yield put(getTypeParamsSuccess(response.params, response.message));
  } catch (error) {
    yield put(getTypeParamsError(error));
  }
}

export function* watchGetParamsType() {
  yield takeEvery(GET_TYPE_PARAMETERS, getTypeParameters);
}

function* getTypeParamsSaga() {
  yield all([fork(watchGetParamsType)]);
}

export default getTypeParamsSaga;
